import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=2d0295fa&"
import script from "./CommentsList.vue?vue&type=script&lang=js&"
export * from "./CommentsList.vue?vue&type=script&lang=js&"
import style0 from "./CommentsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports